import { registerBlockType } from "@wordpress/blocks";
import Edit from "./Edit";
import Save from "./save";
import metadata from "./block.json";
import "./style.scss";

const oldAtributes = metadata.attributes;
delete oldAtributes.textAlign.default

registerBlockType(metadata.name, {
  edit: Edit,
  save: Save,
  icon: {
    foreground: "#0061FE",
    src: (
      <svg
        width="20"
        height="16"
        viewBox="0 0 20 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.693821 0.505114C1.08095 0.191131 1.59439 0 2.13753 0H17.8629C18.406 0 18.9195 0.191131 19.3066 0.505114C19.6903 0.816322 20.0004 1.29569 20.0004 1.87537V10.1281C20.0004 10.5423 19.6646 10.8781 19.2504 10.8781C18.8362 10.8781 18.5004 10.5423 18.5004 10.1281V1.87537C18.5004 1.85485 18.4868 1.77153 18.3617 1.67011C18.2401 1.57145 18.0598 1.5 17.8629 1.5H2.13753C1.94066 1.5 1.76033 1.57145 1.6387 1.67011C1.51364 1.77153 1.5 1.85485 1.5 1.87537V10.1281C1.5 10.1486 1.51364 10.2319 1.6387 10.3333C1.76033 10.432 1.94066 10.5034 2.13753 10.5034H7.30012C7.71434 10.5034 8.05012 10.8392 8.05012 11.2534C8.05012 11.6676 7.71434 12.0034 7.30012 12.0034H2.13753C1.59439 12.0034 1.08095 11.8123 0.693821 11.4983C0.310115 11.1871 0 10.7077 0 10.1281V1.87537C0 1.29569 0.310115 0.816322 0.693821 0.505114Z"
        />
        <path d="M11.0007 11.9974C11.0007 10.8088 11.0001 9.61986 11.0013 8.43123C11.0013 8.15167 11.1788 7.96754 11.4221 8.00382C11.5004 8.0154 11.5829 8.05808 11.6461 8.1093C13.5332 9.63632 15.4179 11.1661 17.3026 12.6965C17.4862 12.8455 17.5367 12.9937 17.475 13.1705C17.412 13.3507 17.2862 13.4281 17.0518 13.4281C16.2857 13.4284 15.5193 13.4318 14.7532 13.4269C14.2723 13.4239 13.8699 13.5946 13.5314 13.947C12.9201 14.5832 12.3009 15.2115 11.6876 15.8456C11.5562 15.9816 11.4096 16.0414 11.2331 15.967C11.0541 15.8917 10.9924 15.7383 11.0007 15.5484C11.0022 15.513 11.0007 15.4774 11.0007 15.4417C11.0007 14.2936 11.0007 13.1455 11.0007 11.9974Z" />
      </svg>
    ),
  },
});
